import { STALE_CLIENT_CLOSE_CODE, STALE_CLIENT_CLOSE_REASON_PREFIX } from "@t3tools/contracts";

export function isStaleClientCloseCode(code: number | null | undefined): boolean {
  return code === STALE_CLIENT_CLOSE_CODE;
}

/** Server version carried by a stale-client close reason; `null` for any other reason. */
export function parseStaleClientCloseReason(reason: string | null | undefined): string | null {
  if (!reason || !reason.startsWith(STALE_CLIENT_CLOSE_REASON_PREFIX)) {
    return null;
  }
  const version = reason.slice(STALE_CLIENT_CLOSE_REASON_PREFIX.length).trim();
  return version.length > 0 ? version : null;
}
